var taricNomenclature= angular.module('taric.nomenclature', ['nomenclature.sbn', 'nomenclature.sbt', 'nomenclature.ct', 'common.model.language']);
taricNomenclature.config(function ($stateProvider) {
    $stateProvider.state('taric.nomenclature', {
                    abstract: true,
                    url: '/nomenclature',
                    template: '<ui-view></ui-view>'
                }).state('taric.nomenclature.sbn', {
                    url: '/sbn?cc&sd&d&l&ql&ea&frm&type&ccField',
                    templateUrl: 'taric/nomenclature/sbn/nomenclature-search.tmpl.html',
                    controller : 'SearchByNomenclatureController as searchByNomenclatureCtrl',
                    reloadOnSearch: false,
                    resolve: {
                        initialGonoTreeSearchCriteria: function(SearchByNomenclatureModel, $stateParams, $translate, $filter, CommonHelper){
                            SearchByNomenclatureModel.resetSearchCriteria();
                            SearchByNomenclatureModel.getSearchCriteria().commodityCode = $filter('commodityCode')($stateParams.cc);
                            if($stateParams.d){
                                if ($stateParams.d === 'I' || $stateParams.d === 'E' || $stateParams.d === 'ER'){
                                    SearchByNomenclatureModel.getSearchCriteria().direction = $stateParams.d;
                                }
                            }
                            if ($stateParams.sd){
                                var inputDate = CommonHelper.parseInputDate($stateParams.sd);
                                if (inputDate) {
                                    SearchByNomenclatureModel.getSearchCriteria().simulationDate = inputDate;
                                }
                            }
                            if ($stateParams.l){
                                $translate.use($stateParams.l);
                                SearchByNomenclatureModel.getSearchCriteria().language = $stateParams.l;
                            }
                            if ($stateParams.ql){
                                SearchByNomenclatureModel.getSearchCriteria().language = $stateParams.ql;
                            }
                            if ($stateParams.ea) {
                                if ($stateParams.ea === 'true') {
                                    SearchByNomenclatureModel.getSearchCriteria().expandAll = true;
                                } else {
                                    SearchByNomenclatureModel.getSearchCriteria().expandAll = false;
                                }
                            }
                            return null;
                        },
                        preferredUILanguages: function(LanguageModel){
                            return LanguageModel.getPreferredUILanguages();
                        },
                        links: function(SearchByNomenclatureModel){
                            return SearchByNomenclatureModel.getLinks(SearchByNomenclatureModel.getSearchCriteria().simulationDate);
                        },
                        loadTranslation: function ($translatePartialLoader) {
                            $translatePartialLoader.addPart('taric/nomenclature/sbn');
                        },
                        setupMenu: function (MenuModel) {
                        	
                        	MenuModel.setHelpIndex(this.name);
                        	MenuModel.notifyObservers();
                        }
                    }
                }).state('taric.nomenclature.ct', {
                    url: '/ct?d&ccs&cce&ds&de&crt&l&frm&cc&ccField',
                    templateUrl: 'taric/nomenclature/ct/correlation-table-search.tmpl.html',
                    controller : 'CorrelationTableController as correlationTableCtrl',
                    reloadOnSearch: false,
                    resolve: {
                        initializeData: function($stateParams, CorrelationTableModel, $translate, CommonHelper){
                            if ($stateParams.frm !== 'ccLookup' && $stateParams.frm !== 'ccView') {
                                CorrelationTableModel.reset();
                            } else if ($stateParams.frm === 'ccLookup') {
                                CorrelationTableModel.resetSearchResult();
                            }
                            if ($stateParams.ccField && $stateParams.cc){
                                if ($stateParams.ccField === 'commodityCodeRangeStart'){
                                    CorrelationTableModel.getSearchCriteria().commodityCodeRangeStart = $stateParams.cc;
                                } else if ($stateParams.ccField === 'commodityCodeRangeEnd'){
                                    CorrelationTableModel.getSearchCriteria().commodityCodeRangeEnd = $stateParams.cc;
                                }
                            }
                            if($stateParams.d){
                                if ($stateParams.d === 'I' || $stateParams.d === 'E'){
                                    CorrelationTableModel.getSearchCriteria().direction = $stateParams.d;
                                }
                            }
                            if ($stateParams.ccs) {
                                CorrelationTableModel.getSearchCriteria().commodityCodeRangeStart = $stateParams.ccs;
                            }
                            if ($stateParams.cce) {
                                CorrelationTableModel.getSearchCriteria().commodityCodeRangeEnd = $stateParams.cce;
                            }
                            if ($stateParams.ds){
                                var startDate = CommonHelper.parseInputDate($stateParams.ds);
                                if (startDate) {
                                    CorrelationTableModel.getSearchCriteria().startDate = startDate;
                                }
                            }
                            if ($stateParams.de){
                                var endDate = CommonHelper.parseInputDate($stateParams.de);
                                if (endDate) {
                                    CorrelationTableModel.getSearchCriteria().endDate = endDate;
                                }
                            }
                            if ($stateParams.crt){
                                if ($stateParams.crt === 'E') {
                                    CorrelationTableModel.getSearchCriteria().correlationType = 'E';
                                } else {
                                    CorrelationTableModel.getSearchCriteria().correlationType = 'N';
                                }
                            }
                            if ($stateParams.l){
                                $translate.use($stateParams.l);
                            }
                        },
                        loadTranslation: function ($translatePartialLoader) {
                            $translatePartialLoader.addPart('taric/nomenclature/ct');
                        },
                        setupMenu: function (MenuModel) {
                        	
                        	MenuModel.setHelpIndex(this.name);
                        	MenuModel.notifyObservers();
                        }
                    }
                }).state('taric.nomenclature.sbt', {
                    url: '/sbt?sd&ts&gnd&add&fnd&ql&l&frm',
                    templateUrl: 'taric/nomenclature/sbt/text-search.tmpl.html',
                    controller : 'SearchByTextController as searchByTextCtrl',
                    reloadOnSearch: false,
                    resolve: {
                        initializeData : function(SearchByTextModel, $stateParams, $translate, CommonHelper){
                            if ($stateParams.frm !== 'ccView' && $stateParams.frm !== 'adcoView' && $stateParams.frm !== 'footnoteView') {
                                SearchByTextModel.reset();
                            }

                            if ($stateParams.sd){
                                var inputDate = CommonHelper.parseInputDate($stateParams.sd);
                                if (inputDate) {
                                    SearchByTextModel.getSearchCriteria().simulationDate = inputDate;
                                }
                            }
                            if ($stateParams.ts){
                                SearchByTextModel.getSearchCriteria().textSearch = $stateParams.ts;
                            }
                            if ($stateParams.gnd) {
                                if ($stateParams.gnd === 'true') {
                                    SearchByTextModel.getSearchCriteria().goodsNomenclatureDescription = true;
                                } else {
                                    SearchByTextModel.getSearchCriteria().goodsNomenclatureDescription = false;
                                }
                            }
                            if ($stateParams.add) {
                                if ($stateParams.add === 'true') {
                                    SearchByTextModel.getSearchCriteria().additionalCodeDescription = true;
                                } else {
                                    SearchByTextModel.getSearchCriteria().additionalCodeDescription = false;
                                }
                            }
                            if ($stateParams.fnd) {
                                if ($stateParams.fnd === 'true') {
                                    SearchByTextModel.getSearchCriteria().footnoteDescription = true;
                                } else {
                                    SearchByTextModel.getSearchCriteria().footnoteDescription = false;
                                }
                            }
                            if ($stateParams.l){
                                $translate.use($stateParams.l);
                                SearchByTextModel.getSearchCriteria().language = $stateParams.l;
                            }
                            if ($stateParams.ql){
                                SearchByTextModel.getSearchCriteria().language = $stateParams.ql;
                            }
                        },
                        preferredUILanguages: function (LanguageModel) {
                            return LanguageModel.getPreferredUILanguages();
                        },
                        loadTranslation: function ($translatePartialLoader) {
                            $translatePartialLoader.addPart('taric/nomenclature/sbt');
                        },
                        setupMenu: function (MenuModel) {
                        	
                        	MenuModel.setHelpIndex(this.name);
                        	MenuModel.notifyObservers();
                        }
                    }
                });
});



// WEBPACK FOOTER //
// ./app/taric/nomenclature/taric-nomenclature.js